import { useEffect, useRef } from 'react'
import { isToastClick, type Point } from '../lib/isToastClick'

/**
 * Calls onClick for clicks anywhere in the sonner toast that contains anchor. Listens
 * natively since the toast element is rendered by sonner, outside our component tree.
 */
export const useToastClick = (
  anchor: HTMLElement | null,
  onClick: (event: MouseEvent) => void
): void => {
  const onClickRef = useRef(onClick)

  useEffect(() => {
    onClickRef.current = onClick
  })

  useEffect(() => {
    const toast = anchor?.closest<HTMLElement>('[data-sonner-toast]')

    if (!toast) {
      return
    }

    let start: Point | undefined

    const handlePointerDown = (event: PointerEvent) => {
      start = { x: event.clientX, y: event.clientY }
    }

    const handleClick = (event: MouseEvent) => {
      if (isToastClick(toast, event, start)) {
        onClickRef.current(event)
      }
    }

    toast.addEventListener('pointerdown', handlePointerDown)
    toast.addEventListener('click', handleClick)

    return () => {
      toast.removeEventListener('pointerdown', handlePointerDown)
      toast.removeEventListener('click', handleClick)
    }
  }, [anchor])
}
